// Seams: config.js and the store are per-app (see services/api.js).
import config from "@/config";
import store from "@/store";

const PLAN_LABELS = {
  free: "Free",
  basic: "Basic",
  pro: "Pro",
  ultra: "Ultra",
  enterprise: "Ultra"
};

// What the platform's "no subscription" state is called. A paid-only site
// may name it ($config.NO_PLAN_LABEL, e.g. "No plan"): it has no Free plan.
function noPlanLabel() {
  const paidOnly = !!(store && store.getters && store.getters.forcePaidPlans);
  return (paidOnly && config && config.NO_PLAN_LABEL) || "Free";
}

export function formatPlanName(planName) {
  if (!planName) {
    return noPlanLabel();
  }

  const value = String(planName).trim();
  const normalized = value.toLowerCase();
  if (normalized === "free") {
    return noPlanLabel();
  }

  if (PLAN_LABELS[normalized]) {
    return PLAN_LABELS[normalized];
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
}
